import * as React from 'react';
import { default as MuiPopper, PopperProps } from '@material-ui/core/Popper';

export const Popper: React.FunctionComponent<PopperProps> = props => <MuiPopper {...props} />;

export default Popper;
